export const SUBTITLE_LANGUAGE_CODES = ['en', 'hi', 'es', 'de', 'fr', 'it'];

export const SUBTITLE_LANG_LABELS = {
  en: 'English',
  hi: 'Hindi',
  es: 'Spanish',
  de: 'German',
  fr: 'French',
  it: 'Italian',
};
